import styled from 'styled-components';
import { colors, s24 } from '@ardoq/design-tokens';
import { FlexBox } from '@ardoq/layout';
import { text1 } from '@ardoq/typography';
import {
  IntegrationWorkspace,
  SavedTransferConfig,
} from '@ardoq/api-types/integrations';
import { IntegrationDate } from '../integrationDate/IntegrationDate';
import {
  DataSourceItem,
  ExpandedRowMapping,
} from '../expandedRowMapping/ExpandedRowMapping';
import { type I18nLocale, t } from '@ardoq/i18n';
import { type Locale } from '@ardoq/locale';

const ConfigText = styled.div`
  ${text1}
`;

const ExpandedTransferConfigContainer = styled(FlexBox).attrs({
  gap: 'medium',
})`
  background-color: ${colors.grey50};
  padding: ${s24};
`;

export function ExpandedTransferConfig({
  lastUpdated,
  lastImported,
  expandedRowDataSource,
  connection,
  onWorkspaceClick,
  i18nLocale,
  locale,
}: Pick<SavedTransferConfig, 'lastUpdated' | 'lastImported'> & {
  expandedRowDataSource: DataSourceItem[];
  connection?: { name: string };
  onWorkspaceClick: ((workspace: IntegrationWorkspace) => void) | null;
  i18nLocale: I18nLocale;
  locale: Locale;
}) {
  return (
    <ExpandedTransferConfigContainer flexDirection="column">
      {connection && (
        <ConfigText>
          {t(
            i18nLocale,
            'integrations:expandedTransferConfig.connectionLabel',
            { name: connection.name },
            'Connection: {{name}}'
          )}
        </ConfigText>
      )}
      <FlexBox justify="space-between" gap="medium">
        <ConfigText>
          {t(
            i18nLocale,
            'integrations:expandedTransferConfig.createdLabel',
            'Created:'
          )}{' '}
          <IntegrationDate
            date={lastUpdated}
            locale={locale}
            i18nLocale={i18nLocale}
            placeholder={t(
              i18nLocale,
              'integrations:expandedTransferConfig.createdPlaceholder',
              'Re-save to update'
            )}
          />
        </ConfigText>
        <ConfigText>
          {t(
            i18nLocale,
            'integrations:expandedTransferConfig.lastImportedLabel',
            'Last imported:'
          )}{' '}
          <IntegrationDate
            date={lastImported}
            locale={locale}
            i18nLocale={i18nLocale}
            placeholder={t(
              i18nLocale,
              'integrations:expandedTransferConfig.lastImportedPlaceholder',
              'not available yet'
            )}
          />
        </ConfigText>
      </FlexBox>
      <ExpandedRowMapping
        dataSource={expandedRowDataSource}
        onWorkspaceClick={onWorkspaceClick}
        i18nLocale={i18nLocale}
      ></ExpandedRowMapping>
    </ExpandedTransferConfigContainer>
  );
}
